export default __webpack_public_path__ + "static/media/sysad.c33ef084.png";